import { ThemeToggleButton } from './ThemeToggleButton'
import styles from './ThemeBar.module.css'

/**
 * LOGISPRD-12506 Task 19 — `dev/ScenarioSwitcher` 의 후신.
 *
 * `ScenarioSwitcher` 는 두 역할을 겸했다: (1) `import.meta.env.DEV` 로만 보이던 "화면 구성 시안 · 1차"
 * 안내 배지(1단계 목데이터 검수용), (2) dev/prod 구분 없이 항상 남는 테마 전환. 2단계 마무리(Task 19)에서
 * 목데이터·시안 안내 장치를 통째로 걷어내면서 (1)은 완전히 삭제하고 (2)만 이 컴포넌트로 옮겼다 — 테마
 * 전환은 시안 검수용이 아니라 실제 화면 기능이라 프로덕션에도 남아야 한다.
 *
 * `.bar`/`.spacer` 레이아웃(배경·패딩·우측 정렬)은 `ScenarioSwitcher.module.css` 에서 그대로 가져왔다 —
 * 안내 배지가 없던 프로덕션 빌드에서 이미 이 모습으로 렌더되고 있었으므로 시각적으로 달라지는 게 없다.
 */
export const ThemeBar = (): JSX.Element => (
  <div className={styles.bar}>
    <span className={styles.spacer} />
    <ThemeToggleButton />
  </div>
)
